module.exports = __webpack_public_path__ + "img/search-bg.b2dc389d.png";